export const insertIf = <T>(condition: boolean | undefined, ...data: T[]) => (condition ? [...data] : []);
